import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import SectionReveal from "@/components/SectionReveal";
import { FinalCta } from "@/components/LandingBits";
import { trackCta } from "@/lib/analytics";

export default function GuidePage({ path, title, description, eyebrow, h1, intro, image, imageAlt, sections, cta, testId }) {
  const click = (loc) => () => trackCta({ cta_name: `${testId}_cta`, cta_text: cta.label, destination_url: cta.to, cta_location: loc });
  return (
    <div data-testid={`${testId}-page`} className="bg-kore-warm">
      <Seo title={title} description={description} path={path} />
      <section className="container-kore pt-16 pb-12 grid lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="display-1 mt-4 text-kore-forest">{h1}</h1>
          <p className="mt-8 text-lg md:text-xl text-kore-ink/80 leading-[1.6] max-w-2xl">{intro}</p>
          <div className="mt-10"><Link to={cta.to} data-testid={`${testId}-cta-top`} onClick={click("hero")} className="btn-primary">{cta.label} <ArrowRight size={14} /></Link></div>
        </div>
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-lift"><img src={image} alt={imageAlt} loading="eager" className="w-full h-full object-cover" /></div>
        </div>
      </section>

      <SectionReveal as="section" className="container-kore py-20 md:py-28 max-w-3xl">
        <div className="space-y-16">
          {sections.map((s, i) => (
            <article key={s.h} data-testid={`${testId}-section-${i}`}>
              <div className="text-kore-gold text-sm font-medium">0{i + 1}</div>
              <h2 className="font-display text-3xl md:text-4xl text-kore-forest mt-3 leading-tight">{s.h}</h2>
              {s.p.map((para, j) => <p key={j} className="mt-5 text-[17px] text-kore-ink/80 leading-[1.7]">{para}</p>)}
              {s.list && <ul className="mt-5 space-y-2 text-[17px] text-kore-ink/80">{s.list.map((li) => <li key={li} className="flex gap-3"><span className="text-kore-gold">—</span>{li}</li>)}</ul>}
            </article>
          ))}
        </div>
      </SectionReveal>

      <FinalCta testId={`${testId}-final`} h2={cta.h2} primary={{ to: cta.to, label: cta.label, onClick: click("footer") }} note={cta.note || "Built for people 40+ · Rowan House, Bowness-on-Windermere"} />
    </div>
  );
}
